import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSparkles2 = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Sparkles2</title>
    <path
      d="m11.389 4.514 2.222 6.014 5.225 2.557-5.225 2.558-2.223 6.014-2.222-6.014-5.225-2.558 5.225-2.557 2.223-6.014ZM22.342 16.314l1.705 4.41 4.01 1.876-4.01 1.876-1.705 4.41-1.705-4.41-4.009-1.876 4.01-1.876 1.704-4.41Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={9.103} cy={27.178} r={2.285} fill="currentColor" />
    <circle cx={22.962} cy={8.564} r={1.714} fill="currentColor" />
  </svg>
);
export default SvgIcoSparkles2;
